import { Controller } from '@hotwired/stimulus'
import { closeDialog } from '../../lib/dialogs.js'

// Lets markup rendered inside a dialog dismiss it, since the sheet is a singleton
// owned by sweetalert and not by the element that opened it.
export default class extends Controller {
  close() {
    closeDialog()
  }
}
